import { createAction, props } from '@ngrx/store';

export const SetTheme = createAction('[Theme] Set theme', props<{ theme: string }>());

export const SetFooterTheme = createAction('[Theme] Set Footer theme', props<{ theme: string }>());
